export const QUESTION_HOME_INSURANCE_MODULE = 'home_insurance_opt_out'
export const QUESTION_BUYER_ADD_HOME = 'buyer_add_home'
